import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initClarity } from '@mustauto/utils/analytics/clarity';
import { initSentry } from './lib/sentry';
import { App } from './App';
import './index.css';

initClarity(import.meta.env.VITE_CLARITY_PROJECT_ID);
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
